//
import { ProductModel } from '@/models'

/**
 *
 */
const fetchById = async id => {
    //
    const includes = ['wh_item', 'wh_subfamily', 'wh_tags'],
        appends = [
            'sale_prices',
            'composition',
            'stocks',
            'discounts',
            'branch_offices',
        ]

    //
    try {
        //
        let promo = await ProductModel.include(includes)
            .append(appends)
            .find(id)

        //
        return promo
    } catch (error) {
        //
        return error.response.data
    }
}

//
export default fetchById
